// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"6d1b768d","316":"2fd6dba7","340":"84bc07db","560":"0e340459","856":"0e340459"}[chunkId] + ".chunk.css";
};